import { CircularProgressbarWithChildren } from 'react-circular-progressbar'

import 'react-circular-progressbar/dist/styles.css'
import { hexToRgb } from 'utils/color'

import type { CircularProgressbarProps } from 'react-circular-progressbar/dist/types'

export type SemiCircularProgressProps = Partial<CircularProgressbarProps> & {
  children?: React.ReactNode
}

const colorProgress = hexToRgb('#0B5AE2')

const SemiCircularProgress = ({
  value = 0,
  children,
  ...props
}: SemiCircularProgressProps) => {
  return (
    <CircularProgressbarWithChildren
      value={value}
      strokeWidth={4}
      circleRatio={0.5}
      styles={{
        root: { transform: 'rotate(0.75turn)' },
        path: {
          stroke: colorProgress,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          shapeRendering: 'geometricPrecision',
        },
      }}
      {...props}
    >
      {children}
    </CircularProgressbarWithChildren>
  )
}

export default SemiCircularProgress
